module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-d6f0a9afb23fd6ae9238e7f6d4e3482d.png";